export { default as Paragraph, default as P } from './Paragraph';
export { default as Headline, default as H } from './Headline';
export { default as Display, default as D } from './Display';
export { default as List } from './List';
export { default as ListItem } from './ListItem';
